import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import SpriteSVG from '@components/1-atoms/SpriteSVG';

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  max-width: 100%;
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
  max-width: 100%;

  &:hover {
    opacity: 0.98;
  }
`;

export const Image = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  object-fit: cover;
`;

export const ZoomIcon = styled(SpriteSVG)`
  position: absolute;
  pointer-events: none;
  transition: all 0.3s ease;
  opacity: 0.3;

  ${({ theme: { spacing, colors } }) => css`
    bottom: ${spacing.level2};
    right: ${spacing.level2};
    width: ${spacing.level6};
    height: ${spacing.level6};
    fill: ${colors.onSurface};
    filter: drop-shadow(0px 2px 4px ${rgba(colors.shadow, 0.4)});
  `}

  ${ImageWrapper}:hover & {
    opacity: 1;
    transform: scale(1.15);
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  cursor: pointer;

  ${({ theme: { colors } }) => css`
    background-color: ${rgba(colors.scrim, 0.8)};
  `}
`;

export const ModalContent = styled.div`
  position: relative;
  cursor: default;
  pointer-events: auto;
  background-color: transparent;
`;

export const ModalImage = styled.img`
  height: 50vh;
  width: 90vw;
  object-fit: contain;

  ${({ theme: { colors, borderRadius } }) => css`
    border-radius: ${borderRadius.large};
    box-shadow: 0 8px 32px ${rgba(colors.shadow, 0.5)};
    background-color: ${colors.surface};
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 1;

  ${({ theme: { spacing, colors, borderRadius } }) => css`
    top: ${spacing.level2};
    right: ${spacing.level2};
    width: ${spacing.level7};
    height: ${spacing.level7};
    border-radius: ${borderRadius.full};
    background-color: ${colors.surface};
    box-shadow: 0 4px 16px ${rgba(colors.shadow, 0.4)};

    &:hover {
      background-color: ${colors.surfaceContainerHighest};
      transform: scale(1.08);
      box-shadow: 0 6px 20px ${rgba(colors.shadow, 0.5)};
    }

    &:active {
      transform: scale(0.95);
    }
  `}
`;

export const CloseIcon = styled(SpriteSVG)`
  ${({ theme: { spacing, colors } }) => css`
    width: ${spacing.level5};
    height: ${spacing.level5};
    fill: ${colors.onSurface};
  `}
`;
